import React, { useState } from "react";
import iconCheckWhite from "../images/icon-check-white.png";

function PriceSwitcher({ activeTab, setActiveTab }) {
  return (
    <div className="price-switcher">
      <button
        className={`price-switcher-btn ${activeTab === "packs" ? "active" : ""}`}
        onClick={() => setActiveTab("packs")}
      >
        Packs
        {activeTab === "packs" && <span className="price-switcher-icon">
            <img src={iconCheckWhite} alt=""/>
            </span>}
      </button>
      <button
        className={`price-switcher-btn ${activeTab === "abonnements" ? "active" : ""}`}
        onClick={() => setActiveTab("abonnements")}
      >
        {activeTab === "abonnements" && <span className="price-switcher-icon">
            <img src={iconCheckWhite} alt=""/>
            </span>}
        Abonnements
      </button>
    </div>
  );
}

export default PriceSwitcher;
